module.exports = ".history-info {\r\n    background-color: #e8f1f2;\r\n    margin-bottom: 20px;\r\n    text-align: left;\r\n    color: #13293d;\r\n    padding: 20px;\r\n}\r\n\r\nng2-smart-table { \r\n    font-size: 14px;\r\n    line-height: 1.42857143;    \r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/device-history/device-history.component.css
// module id = ./src/app/components/device-history/device-history.component.css
// module chunks = main